// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__ExYel","info":"styles_info__aVsS8","button":"styles_button__1VY9I","selected":"styles_selected__Aw77Q","videoWrapper":"styles_videoWrapper__sJPRI"};